"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformBreakpointToCSSMediaQuery = exports.transformBreakpointToMediaQuerySpan = void 0;
const transformBreakpointToEmNumber_1 = require("./transformBreakpointToEmNumber");
const nextBreakpointEms = (breakpoint) => {
    const nextBreakpoint = breakpoint + 1;
    return (0, transformBreakpointToEmNumber_1.transformBreakpointToEmNumber)(nextBreakpoint);
};
const transformBreakpointToMediaQuerySpan = (breakpoint, direction) => {
    let mediaQuerySpan;
    const breakpointEms = (0, transformBreakpointToEmNumber_1.transformBreakpointToEmNumber)(breakpoint);
    switch (direction) {
        case "down":
            mediaQuerySpan = `(max-width: ${breakpointEms - 0.00125}em)`;
            break;
        case "only":
            mediaQuerySpan = `(min-width: ${breakpointEms}em) and (max-width: ${nextBreakpointEms(breakpoint) - 0.00125}em)`;
            break;
        case "up":
        default:
            mediaQuerySpan = `(min-width: ${breakpointEms}em)`;
            break;
    }
    return mediaQuerySpan;
};
exports.transformBreakpointToMediaQuerySpan = transformBreakpointToMediaQuerySpan;
const transformBreakpointToCSSMediaQuery = (breakpoint, span) => `@media ${(0, exports.transformBreakpointToMediaQuerySpan)(breakpoint, span)}`;
exports.transformBreakpointToCSSMediaQuery = transformBreakpointToCSSMediaQuery;
//# sourceMappingURL=transformBreakpointToCSSMediaQuery.js.map